export default __webpack_public_path__ + "static/quokka-e31cd667fed6c4b3071ce178293ee27d.png";